import { createMutationHook } from '~/shared/providers/api';

export const useCreateAssetTypeMutation = createMutationHook(
  'transportation.assetTypeCreate',
  (params: { name: string; description: string; capacity: number }) => ({
    transportationAssetTypeCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
          capacity: params.capacity,
        },
      },
      id: true,
      name: true,
      description: true,
      capacity: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
